/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box, { shouldForwardProp: (prop) => prop !== 'report' })(({ report }) => ({
  gap: "20px",
  paddingBottom: report && "16px",
  marginBottom: !report && "32px",
}));

export const StyledTypography = styled(Typography, { shouldForwardProp: (prop) => prop !== 'report' })(({ report }) => ({
  fontSize: "1.4rem",
  fontWeight: 600,
  padding: "22px 0px 10px 0px",
}));
